/**
 * Wraps Tailwind CSS class strings or objects containing class strings to apply
 * class sorting by `prettier-plugin-tailwindcss`
 *
 * Tailwind CSS のクラス文字列、またはクラス文字列を含むオブジェクトをラップし、
 * `prettier-plugin-tailwindcss` によるクラスのソートを適用させるための関数です。
 *
 * @description
 * This function doesn't modify the input value, it returns it as-is.
 * Its purpose is to enable Prettier to apply Tailwind class sorting.
 *
 * この関数は入力値を変更せず、そのまま返します。
 * ただし、Prettier による Tailwind クラスのソートを適用させる目的で使用します。
 *
 * @template T - The type of the input value / 入力値の型
 * @param value - The value to wrap (string or object) / ラップする値（文字列またはオブジェクト）
 * @returns The same value passed in / 渡された同じ値
 *
 * @example
 * // Using with strings / 文字列を使用する場合
 * const className = tw("text-white bg-blue-500 px-4 py-2");
 * // After Prettier formatting / Prettier によるフォーマット後:
 * const className = tw("bg-blue-500 px-4 py-2 text-white");
 *
 * @example
 * // Using with objects / オブジェクトを使用する場合
 * const styles = tw({
 *   button: "text-white bg-blue-500 px-4 py-2",
 *   alert: "text-red-500 bg-yellow-100 p-3",
 * });
 * // After Prettier formatting / Prettier によるフォーマット後:
 * const styles = tw({
 *   button: "bg-blue-500 px-4 py-2 text-white",
 *   alert: "bg-yellow-100 p-3 text-red-500",
 * });
 */
export const tw = <T>(value: T) => value;
